<script setup lang="ts">
    import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroupField from './EmployeeChangesGroupField.vue';
    import { Alert } from '@/components/ui/alert';
    import type { AlertVariants } from '@/components/ui/alert';

    withDefaults(
        defineProps<{
            data?: ChangedFields;
            values: {
                name: string;
                group: string;
                key: string;
                oldValue?: string | number;
                realValue?: string | number;
                updateValue?: string;
                translation?: string;
            }[];
            employee?: Employee;
            alert?: string;
            alertVariant?: AlertVariants['variant'];
        }>(),
        {
            alertVariant: 'warning',
        },
    );
</script>

<template>
    <div class="flex flex-col gap-6">
        <Alert
            v-if="alert"
            :variant="alertVariant"
        >
            {{ alert }}
        </Alert>
        <EmployeeChangesGroupField
            v-for="value in values"
            :key="value.name"
            :data="data"
            :name="value.name"
            :group="value.group"
            :groupKey="value.key"
            :oldValue="value.oldValue"
            :realValue="value.realValue"
            :updateValue="value.updateValue"
            :employee="employee"
            :translation="value.translation"
        />
    </div>
</template>
